<template>
  <div class="bg-light" style="padding-top: 65px;">
    <NavbarComponent />
    <router-view></router-view>
  </div>
</template>

<script>
import NavbarComponent  from '../components/NavbarComponent'
export default {
  name: 'SignedInView',
  components: {
    NavbarComponent
  }
}
</script>